import React from "react";

export const CloseButtonMobile = React.createContext({});
